<!--
 * @Author: wangjiaxiang
 * @Date: 2022-06-29 14:43:32
 * @LastEditTime: 2022-07-01 02:30:09
 * @LastEditors: wangjiaxiang
 * @Description: 全部专题展示隐藏组件
 * @FilePath: /xingmahui_front/src/views/contents/foodColumn/component/allProjects.vue
 * 
-->
<template>
  <div>
    <van-popup
      :duration="0"
      :overlay="false"
      v-model="popupShow"
      position="bottom"
      :style="{ height: popupHeight + 'px' }"
    >
      <div class="project-all">
        <div
          class="project-list"
          v-for="(item, index) in data"
          :key="index"
          @click="switchVideo(item)"
        >
          <div class="project-list-line">
            <div class="project-list-content">
              <div class="left-image" v-lazy:background-image="item.imgUrl">
                <img
                  v-if="item.id == activeSonId"
                  src="@/assets/images/food/there_is.png"
                  alt=""
                />
              </div>
              <div class="right-content">
                <p
                  :style="
                    item.id == activeSonId
                      ? 'color:#FF8E6B;height:40px;'
                      : 'height:40px;'
                  "
                >
                  {{ item.recipeName }}
                </p>
                <p>
                  <span v-if="item.recipeTag">
                    <span
                      class="tag"
                      v-for="(ite, ind) in item.recipeTag
                        .split(',')
                        .slice(0, 2)"
                      :key="ind"
                      >{{ ite }}</span
                    >
                  </span>
                  <!-- <span>喂养攻略</span> -->
                </p>
                <p>
                  <span class="interaction">
                    <img src="@/assets/images/food/play_icon.png" alt="" />
                    <span>{{ fomatterNum(item.playNum) || 0 }}</span>
                  </span>
                  <span class="interaction">
                    <img src="@/assets/images/food/collect2_icon.png" alt="" />
                    <span>{{ fomatterNum(item.likeNum) || 0 }}</span>
                  </span>
                  <span class="interaction">
                    <img src="@/assets/images/food/like2_icon.png" alt="" />
                    <span>{{ fomatterNum(item.collectNum) || 0 }}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["popupShow", "popupHeight", "data", "activeSonId"],
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    // 格式化数字
    fomatterNum(num) {
      if (num) {
        var num = (num || 0).toString(),
          result = "";
        if (num.length > 4) {
          var h = num.substring(num.length - 4, num.length - 3);
          result =
            num.substring(0, num.length - 4) +
            (h === "0" ? "" : ".") +
            (h === "0" ? "" : h) +
            "万";
          return result;
        }
        return num;
      } else {
        return 0;
      }
    },
    switchVideo(item){
        this.$emit("switchVideo",item)
    }
  },
};
</script>
<style lang="less" scoped>
// 专题全部展开
.project-all {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  .project-list {
    // box-sizing: border-box;
    padding-top: 13px;
    width: 100%;
    height: 89px;
    background: #ffffff;
    &:nth-of-type(1) {
      padding-top: 0px;
    }
    .project-list-line {
      margin: 0 auto;
      box-sizing: border-box;
      width: 343px;
      height: 100%;
      border-bottom: 1px solid #f2f2f2;
      .project-list-content {
        width: 100%;
        height: 78px;
        .left-image {
          position: relative;
          float: left;
          width: 128px;
          height: 78px;
          background-size: 100% 100% !important;
          border-radius: 8px;
          img {
            left: 0;
            bottom: 0;
            position: absolute;
            width: 59px;
            height: 18px;
          }
        }
        .right-content {
          position: relative;
          width: 207px;
          height: 78px;
          // background: green;
          float: right;
          p:nth-of-type(1) {
            font-size: 14px;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
            overflow: hidden;
          }
          p:nth-of-type(2) {
            margin-top: 4px;
            span {
              display: flex;
              .tag {
                text-align: center;
                line-height: 21px;
                display: block;
                width: 60px;
                height: 20px;
                background: #fef4de;
                border-radius: 10px;
                font-size: 11px;
                color: #b18925;
              }
              span:nth-of-type(2) {
                margin-left: 8px;
              }
            }
          }
          p:nth-of-type(3) {
            position: absolute;
            bottom: 0;
            box-sizing: border-box;
            display: flex;
            padding-right: 20px;
            box-sizing: border-box;
            margin-top: 3px;
            .interaction {
              margin-left: 31px;
              &:nth-of-type(1) {
                margin-left: 0px;
              }
            }
            span {
              height: 10px;
              line-height: 10px;
              display: inline-block;
              display: flex;
              // align-items: center;
              font-size: 10px;
              color: #999999;
              img {
                width: 10px;
                height: 10px;
                margin-right: 4px;
              }
              span {
                margin-top: 1px;
                display: inline-block;
                height: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
